import { render } from "./ISelect.vue?vue&type=template&id=095079e0"
import script from "./ISelect.vue?vue&type=script&lang=js"
export * from "./ISelect.vue?vue&type=script&lang=js"

import "./ISelect.vue?vue&type=style&index=0&id=095079e0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__